import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-gradient-to-br from-orange-600 via-pink-600 to-rose-600 text-white relative overflow-hidden">
      <div className="absolute inset-0 opacity-20">
        <div className="absolute top-0 left-0 w-96 h-96 bg-yellow-400 rounded-full blur-3xl"></div>
        <div className="absolute bottom-0 right-0 w-96 h-96 bg-orange-400 rounded-full blur-3xl"></div>
      </div>
      
      <div className="container mx-auto px-6 py-16 relative z-10">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand */}
          <div>
            <div className="flex items-center space-x-3 mb-4">
              <div className="w-16 h-16 flex items-center justify-center bg-white rounded-2xl p-2 shadow-xl">
                <img 
                  src="https://static.readdy.ai/image/34c54877ea329bad86119ae5706d9da2/b68a85387ffbddbea6107dda1317d9b3.png" 
                  alt="Tenny & Co Artistry Logo"
                  className="w-full h-full object-contain"
                />
              </div>
              <div>
                <h3 className="text-2xl font-bold drop-shadow-lg" style={{ fontFamily: '"Pacifico", serif' }}>
                  Tenny & Co Artistry
                </h3>
              </div>
            </div>
            <p className="text-white/90 mb-4 italic font-semibold text-lg">We have got much to offer</p>
            <p className="text-white/80 text-base">
              Port Harcourt's premier art and design brand, delivering excellence in creativity and education.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-2xl font-bold mb-6 drop-shadow-lg">Quick Links</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/" className="text-white/90 hover:text-white transition-colors cursor-pointer font-semibold text-lg hover:translate-x-2 inline-block transform">
                  🏠 Home
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-white/90 hover:text-white transition-colors cursor-pointer font-semibold text-lg hover:translate-x-2 inline-block transform">
                  ℹ️ About Us
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-white/90 hover:text-white transition-colors cursor-pointer font-semibold text-lg hover:translate-x-2 inline-block transform">
                  ⚡ Services
                </Link>
              </li>
              <li>
                <Link to="/portfolio" className="text-white/90 hover:text-white transition-colors cursor-pointer font-semibold text-lg hover:translate-x-2 inline-block transform">
                  🎨 Portfolio
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-white/90 hover:text-white transition-colors cursor-pointer font-semibold text-lg hover:translate-x-2 inline-block transform">
                  📧 Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-2xl font-bold mb-6 drop-shadow-lg">Contact Us</h4>
            <ul className="space-y-4">
              <li className="flex items-start">
                <div className="w-10 h-10 bg-white/20 rounded-full flex items-center justify-center mr-3 flex-shrink-0">
                  <i className="ri-phone-line text-white text-xl"></i>
                </div>
                <div>
                  <a href="tel:08162117807" className="text-white/90 hover:text-white transition-colors cursor-pointer block font-semibold text-lg">
                    08162117807
                  </a>
                  <a href="tel:09032271030" className="text-white/90 hover:text-white transition-colors cursor-pointer block font-semibold text-lg">
                    09032271030
                  </a>
                </div>
              </li>
              <li className="flex items-start">
                <div className="w-10 h-10 bg-white/20 rounded-full flex items-center justify-center mr-3 flex-shrink-0">
                  <i className="ri-map-pin-line text-white text-xl"></i>
                </div>
                <div className="text-white/90 font-semibold">
                  <p>Rukpokwu, Port Harcourt</p>
                  <p>Rumuodara, Port Harcourt</p>
                </div>
              </li>
            </ul>
          </div>

          {/* Social Media */}
          <div>
            <h4 className="text-2xl font-bold mb-6 drop-shadow-lg">Follow Us</h4>
            <div className="flex flex-wrap gap-3">
              <a 
                href="https://instagram.com/tennysartistry" 
                target="_blank" 
                rel="noopener noreferrer"
                className="w-12 h-12 bg-white/20 hover:bg-white hover:text-orange-600 rounded-full flex items-center justify-center transition-all cursor-pointer transform hover:scale-110 shadow-lg"
              >
                <i className="ri-instagram-line text-2xl"></i>
              </a>
              <a 
                href="https://facebook.com/Tennysonsart" 
                target="_blank" 
                rel="noopener noreferrer"
                className="w-12 h-12 bg-white/20 hover:bg-white hover:text-orange-600 rounded-full flex items-center justify-center transition-all cursor-pointer transform hover:scale-110 shadow-lg"
              >
                <i className="ri-facebook-fill text-2xl"></i>
              </a>
              <a 
                href="https://tiktok.com/tennysartistry" 
                target="_blank" 
                rel="noopener noreferrer"
                className="w-12 h-12 bg-white/20 hover:bg-white hover:text-orange-600 rounded-full flex items-center justify-center transition-all cursor-pointer transform hover:scale-110 shadow-lg"
              >
                <i className="ri-tiktok-line text-2xl"></i>
              </a>
              <a 
                href="https://youtube.com/artfultaleswithtennyson" 
                target="_blank" 
                rel="noopener noreferrer"
                className="w-12 h-12 bg-white/20 hover:bg-white hover:text-orange-600 rounded-full flex items-center justify-center transition-all cursor-pointer transform hover:scale-110 shadow-lg"
              >
                <i className="ri-youtube-fill text-2xl"></i>
              </a>
              <a 
                href="https://x.com/Tennysonsart" 
                target="_blank" 
                rel="noopener noreferrer"
                className="w-12 h-12 bg-white/20 hover:bg-white hover:text-orange-600 rounded-full flex items-center justify-center transition-all cursor-pointer transform hover:scale-110 shadow-lg"
              >
                <i className="ri-twitter-x-line text-2xl"></i>
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-white/20 relative z-10">
        <div className="container mx-auto px-6 py-6">
          <div className="flex flex-col md:flex-row justify-between items-center text-base text-white/90">
            <p className="font-semibold">&copy; {new Date().getFullYear()} Tenny & Co Artistry. All rights reserved.</p>
            <a 
              href="https://readdy.ai/?origin=logo" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-white/90 hover:text-white transition-colors cursor-pointer mt-2 md:mt-0 font-semibold"
            >
              Website Builder
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}